import { AuthenticatedHttp } from '../../http/axios';
import { AppError, parsePaginationResponse } from '../../utils/api';

export const getAffiliates = async ({
  page,
  search,
  type,
  status,
  limit = 10,
  filter = {},
  url = '',
}) => {
  const params = {
    page,
    search,
    limit,
    status,
    type,
    url,
    ...(filter?.products?.length > 0 && {
      productPk: filter.products,
    }),
    ...(filter?.userEmail && {
      userEmail: filter.userEmail,
    }),
    ...(status?.length > 0 && {
      status,
    }),
  };

  return AuthenticatedHttp.get(`/affiliates/${url}`, { params })
    .then(parsePaginationResponse)
    .catch((error) => {
      throw new AppError(error);
    });
};

export const createAffiliateService = async ({ productPk, userEmail, isFromShowcase = false }) =>
  AuthenticatedHttp.post('/affiliates/', {
    productPk,
    userEmail,
    is_from_showcase: isFromShowcase,
  })
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const updateAffiliateService = async ({ id, info }) =>
  AuthenticatedHttp.put(`/affiliates/${id}/`, info)
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const acceptAffiliateService = async (ids) =>
  AuthenticatedHttp.post(`/affiliates/accept_many/`, {
    ids,
  })
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const blockAffiliateService = async (ids) =>
  AuthenticatedHttp.post(`/affiliates/block_many/`, {
    ids,
  })
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const unblockAffiliateService = async (ids) =>
  AuthenticatedHttp.post(`/affiliates/unblock_many/`, {
    ids,
  })
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const rejectAffiliateService = async (ids) =>
  AuthenticatedHttp.post(`/affiliates/reject_many/`, { ids })
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const deleteAffiliateService = async ({ id }) =>
  AuthenticatedHttp.delete(`/affiliates/${id}/`)
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });
